import React, {useEffect, useState} from 'react';
import Header from 'components/Header';
import Sidebar from 'components/Sidebar';
import Tabs from 'components/Tabs';
import {useDispatch, useSelector} from 'react-redux';
import {CategoryTypes, PageTypes} from 'enums';
import {useInjectSaga} from 'utils/injectSaga';
import readerSaga from 'sagas/readerSaga';
import categorySaga from 'sagas/categorySaga';
import {fetchCompanies} from 'actions/readerActions';
import {fetchCategories} from 'actions/categoryActions';
import '../style.scss';
import PostsFooter from './PostFooter';
import Filters from './Filters';
import PostTable from './PostTable';
import ReaderInformation from './ReaderInformation';

const ReaderPosts = ({match}) => {
  const dispatch = useDispatch();
  useInjectSaga({key: 'reader', saga: readerSaga});
  useInjectSaga({key: 'category', saga: categorySaga});

  const posts = useSelector((state) => state.reader);

  const categories = useSelector((state) => state.category.sharedList);

  const [countries, setCountries] = useState([]);
  const [groups, setGroups] = useState([]);

  const [postFilters, setPostFilter] = useState({});
  const [selected, setSelected] = useState([]);

  const [pageFilter, setPageFilter] = useState({
    pageSize: 20,
    pageNumber: 0,
  });

  let tabs = groups.map((page) => ({value: page._id, label: page.title}));

  tabs = [
    {
      value: 'all',
      label: 'All',
    },
    ...tabs,
    {value: 'custom', label: 'OTHERS'},
  ];

  const [selectedTab, setSelectedTab] = useState(null);

  useEffect(() => {
    if (selectedTab && tabs.find((f) => f.value === selectedTab.value)) return;

    setSelectedTab(tabs[0]);
  }, [tabs]);

  useEffect(() => {
    if (!selectedTab) return;
    getPosts();
  }, [selectedTab, postFilters, pageFilter, match.path]);

  const getPosts = () => {
    const filters = {
      ...postFilters,
    };

    if (selectedTab.value === 'all' || selectedTab.value === 'custom') {
      delete filters.pageFolderId;
    } else {
      filters.categoryId = selectedTab.value;
    }

    if (selectedTab.value === 'custom') {
      filters.isCustom = true;
    }
    if (filters.label) {
      filters.label = filters.label._id;
    }

    filters.pageType = PageTypes.Company;
    dispatch(fetchCompanies({...filters, ...pageFilter}));
  };

  useEffect(() => {
    dispatch(fetchCategories());
  }, []);

  useEffect(() => {
    const country = categories.find(
      (c) => c.type === CategoryTypes.Country || c.type === 'COUNTRY'
    );
    if (country) {
      setCountries(
        country.categories.reduce((list, current) => {
          list = [
            ...list,
            ...current.subCategories.reduce((subs, subCurrent) => {
              subs.push({...subCurrent.categoryId});
              return subs;
            }, []),
          ];
          return list;
        }, [])
      );
    }

    const group = categories.find((c) => c.type === CategoryTypes.Group);

    if (group) {
      setGroups(
        group.categories.reduce((list, current, index) => {
          if (index < 7) list.push({...current.categoryId});

          return list;
        }, [])
      );
    }
  }, [categories]);

  return (
    <>
      <Header />
      <div className="wrapper">
        <Sidebar />
        <div className="content_wrapper position-relative">
          <ReaderInformation />
          <div className="tab-box">
            <Tabs
              tabs={tabs}
              active={selectedTab}
              onChange={(tab) => setSelectedTab(tab)}
            />

            <div className="tab-content p-4 bg-white min-500">
              <Filters
                pageType={
                  match.path.indexOf('information') > -1
                    ? PageTypes.Information
                    : undefined
                }
                countries={countries}
                selected={selected}
                labels={posts.labels}
                folders={tabs.filter((f) => f.value !== 'all')}
                onAction={(action) => {
                  if (action.label === 'Delete') {
                    // do something
                  }
                }}
                onChange={(filters) => {
                  if (!selectedTab) return;
                  setPostFilter(filters);
                }}
              />
              <PostTable
                labels={posts.labels}
                folders={tabs.filter((f) => f.value !== 'all')}
                posts={posts.companies}
                selected={selected}
                setSelected={setSelected}
                onRefresh={getPosts}
                countries={countries}
              />

              <PostsFooter
                pageFilter={pageFilter}
                setPageFilter={setPageFilter}
                onChange={() => {}}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReaderPosts;
